import React from "react";
import { FaCogs, FaExternalLinkAlt } from "react-icons/fa";
import { SectionCard } from "../SectionCard";

const ACCENT = "#0f766e";

const ADDY_APP_URL_PROD = "https://app.addy.so";
const ADDY_APP_URL_DEV = "https://devmail.addy.so";

/**
 * Processing status lives on the main `api` Cloud Function under org-member
 * auth, so it can't be fetched from the admin portal's admin-auth context. For
 * v1 this section is a launcher: it links to the global Processing Monitoring
 * tool and deep-links into the org's loan board in the client app.
 */
export default function ProcessingSection({ organizationId, env }) {
  const appBase = env === "dev" ? ADDY_APP_URL_DEV : ADDY_APP_URL_PROD;
  const boardUrl = `${appBase}/loans?tab=board`;

  return (
    <SectionCard
      title="Loan Processing"
      subtitle="Processing health & status"
      icon={<FaCogs />}
      accent={ACCENT}
      size="full"
      link={{ to: "/processing-monitoring", label: "Open Processing Monitoring" }}
    >
      <div className="oo-empty-hint" style={{ textAlign: "left", padding: "4px 0 12px" }}>
        Live processing status is served under org-member auth, so it isn't
        embedded here yet. Use Processing Monitoring to inspect pipeline health,
        or jump straight into this org's loan board.
      </div>
      <a
        className="oo-mini-btn"
        href={boardUrl}
        target="_blank"
        rel="noopener noreferrer"
        title={organizationId}
      >
        Open loan board <FaExternalLinkAlt style={{ fontSize: 10 }} />
      </a>
    </SectionCard>
  );
}
